(function () {
  // Slots grandes con fotos variadas (galería, banner, servicios, about): el JS
  // pinta el bg con el color del borde de la foto.
  // EXCLUIDO de la detección automática: slots de PRODUCTO (cards, quick view,
  // página de producto). Las fotos de producto van siempre sobre blanco puro
  // por regla del proyecto, así que el bg se fija en CSS como #ffffff y no se
  // muestrea para evitar tonos beige residuales del JPEG.
  const TARGETS = '.af-photo-gallery__slide img, .af-photo-gallery__thumb img, .af-photo-feed__item img, .af-banner img, .af-about-photo img, .af-service-item__media img, .af-ba-stage img, .af-ba-after-wrap img, .af-spa-images img, .af-spa-image img, .af-accordion-trigger__image img, .af-accordion-gallery figure img, .af-services-photo-grid figure img, .af-lightbox-inner img';

  // Tamaño del downsample. 32×32 nos da ~120 píxeles de perímetro = mediana estable.
  const SAMPLE = 32;
  // Si el resultado es lo bastante claro, lo snap-eamos a blanco puro para que matchee
  // con tarjetas/cards que tienen #fff. Umbral generoso: cualquiera con luma > 240.
  const WHITE_SNAP = 240;
  // Solo procesar imágenes con tamaño natural >= esto. Por debajo el muestreo no es fiable.
  const MIN_NATURAL = 200;

  function median(arr) {
    arr.sort((a, b) => a - b);
    const m = Math.floor(arr.length / 2);
    return arr.length % 2 ? arr[m] : Math.round((arr[m - 1] + arr[m]) / 2);
  }

  function sampleEdge(src) {
    return new Promise(function (resolve) {
      const probe = new Image();
      probe.crossOrigin = 'anonymous';
      probe.onload = function () {
        try {
          if (probe.naturalWidth < MIN_NATURAL || probe.naturalHeight < MIN_NATURAL) {
            return resolve(null);
          }
          const cv = document.createElement('canvas');
          cv.width = SAMPLE;
          cv.height = SAMPLE;
          const ctx = cv.getContext('2d', { willReadFrequently: true });
          ctx.drawImage(probe, 0, 0, SAMPLE, SAMPLE);
          // Sample top row, bottom row, left col, right col (perimeter only).
          const data = ctx.getImageData(0, 0, SAMPLE, SAMPLE).data;
          const rs = [], gs = [], bs = [];
          function push(x, y) {
            const i = (y * SAMPLE + x) * 4;
            rs.push(data[i]); gs.push(data[i + 1]); bs.push(data[i + 2]);
          }
          for (let x = 0; x < SAMPLE; x++) { push(x, 0); push(x, SAMPLE - 1); }
          for (let y = 1; y < SAMPLE - 1; y++) { push(0, y); push(SAMPLE - 1, y); }
          let r = median(rs), g = median(gs), b = median(bs);
          // Luma aprox (Rec. 709) → si la mediana del perímetro es mayoritariamente clara,
          // snap a blanco puro para encajar con cards/cards bg = #fff.
          const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b;
          if (luma >= WHITE_SNAP) { r = 255; g = 255; b = 255; }
          resolve('rgb(' + r + ',' + g + ',' + b + ')');
        } catch (_e) { resolve(null); }
      };
      probe.onerror = function () { resolve(null); };
      probe.src = src;
    });
  }

  async function applyEdgeColor(img) {
    if (!img || img.dataset.afFitDone === '1') return;
    img.dataset.afFitDone = '1';
    const src = img.currentSrc || img.src;
    if (!src) return;
    const color = await sampleEdge(src);
    if (color) img.style.backgroundColor = color;
  }

  function scan(root) {
    (root || document).querySelectorAll(TARGETS).forEach(applyEdgeColor);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (const m of muts) {
        if (m.type === 'childList') {
          m.addedNodes.forEach(function (n) {
            if (n.nodeType !== 1) return;
            if (n.matches && n.matches(TARGETS)) applyEdgeColor(n);
            else if (n.querySelectorAll) scan(n);
          });
        } else if (m.type === 'attributes' && m.target.matches && m.target.matches(TARGETS)) {
          delete m.target.dataset.afFitDone;
          applyEdgeColor(m.target);
        }
      }
    }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['src', 'srcset'] });
  }
})();
